import type {
  Automation,
  AutomationOptions,
  AutomationPayload,
  Channel,
  Unit
} from "../../SettingsAutomation/types/automation.types.ts"
import type { SmsStatus } from "../types/communication.types.ts"

export const MEETING_AUTOMATION_CATEGORIES = [
  "MEETING_REMINDER",
  "MEETING_FOLLOW_UP"
] as const

export const isMeetingAutomation = (automation: Automation) =>
  (MEETING_AUTOMATION_CATEGORIES as readonly string[]).includes(
    automation.category
  )

export interface MeetingAutomationDraft {
  initial_delay_value: number
  initial_delay_unit: Unit
  channel: Channel
  source_template: string | null
  subject: string
  body: string
  sender_user: string | null
  meeting_categories: string[]
}

export const draftOf = (automation: Automation): MeetingAutomationDraft => ({
  initial_delay_value: automation.initial_delay_value,
  initial_delay_unit: automation.initial_delay_unit,
  channel: automation.channel,
  source_template: automation.source_template,
  subject: automation.subject,
  body: automation.body,
  sender_user: automation.sender_user,
  meeting_categories: automation.meeting_categories ?? []
})

export const toPayload = (
  automation: Automation,
  draft: MeetingAutomationDraft
): AutomationPayload & { revision: number } => ({
  name: automation.name,
  category: automation.category,
  channel: draft.channel,
  initial_delay_value: draft.initial_delay_value,
  initial_delay_unit: draft.initial_delay_unit,
  cadence_value: null,
  cadence_unit: null,
  send_count: 1,
  source_template: draft.source_template,
  subject: draft.channel === "SMS" ? "" : draft.subject,
  body: draft.body,
  sender_user: draft.sender_user ?? "",
  meeting_categories: draft.meeting_categories,
  revision: automation.revision
})

export type SmsUnavailableReason = "registering" | "notReady" | "comingSoon"

export const smsUnavailableReason = (
  options: AutomationOptions | null,
  smsStatus: SmsStatus | null
): SmsUnavailableReason | null => {
  if (smsStatus === "registering" || smsStatus === "needs_details")
    return "registering"
  if (smsStatus !== "active") return "notReady"
  const sms = options?.channels.find((channel) => channel.key === "SMS")
  return sms?.status === "available" ? null : "comingSoon"
}
